import { Box, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

const EmptyChatState: React.FC = () => {
  const { colors } = useCelleraTheme();

  return (
    <Box
      sx={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: colors.background.grayLight,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 1,
      }}
    >
      <Typography variant="h6" sx={{ color: colors.text.secondary }}>
        Select to view a conversation.
      </Typography>
    </Box>
  );
};

export default EmptyChatState;
